<div class="main-layout flex flex-column">
  <app-partner-style *ngIf="partnerBrandService.data.partner && partnerBrandService.data.partner.brand"></app-partner-style>

  <div class="text-center margin-top-xxbig flex-grow">
    <open-svg-icon name="500" class="medium margin-top-medium margin-bottom-large" *ngIf="!partnerBrandService.data.partner.slug || partnerBrandService.data.partner.slug === 'open'"></open-svg-icon>

    <div class="margin-top-xlarge margin-bottom-large partner-logo" *ngIf="partnerBrandService.data.partner.slug !== 'open'"></div>

    <h1 class="margin-bottom-medium">Your magic link has expired. Visit the homepage to grab a new one.</h1>

    <button
      mat-flat-button color="primary" type="button"
      *ngIf="partnerBrandService.data.partner && partnerBrandService.data.partner.companyInfo && partnerBrandService.data.partner.companyInfo.BASE_DOMAIN"
      (click)="gotToHomePage()"
    >Back to homepage
    </button>
  </div>
</div>
